import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import cn from 'classnames';
import { Box, Card, Collapse, Row, Typography } from 'seagull';
import { ChevronDown, ChevronUp } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from './SectionCard.module.scss';
export const GetSectionCardTID = (parentTestId)=>getTestIds(parentTestId);
export function SectionCard(param) {
    let { bi, testId, title, actions, children, bodyClassName } = param;
    const { SectionCardTestIds: TID } = useMemo(()=>GetSectionCardTID(testId), [
        testId
    ]);
    const { t: summaryTexts } = useLocaleKeys('pages.clientDetail.summary');
    const isMobile = useIsMobileForHomePage();
    const [expanded, setExpanded] = useState(!isMobile);
    if (isMobile) {
        const toggle = ()=>setExpanded((prev)=>!prev);
        const stopBubble = (e)=>e.stopPropagation();
        return /*#__PURE__*/ _jsxs(Box, {
            testId: testId,
            className: styles.mobileCard,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    justifyContent: "space-between",
                    className: styles.mobileHeader,
                    onClick: toggle,
                    role: "button",
                    "aria-expanded": expanded,
                    "aria-label": expanded ? summaryTexts.collapseSection() : summaryTexts.expandSection(),
                    testId: TID.ToggleButton(),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            weight: "bold",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 12,
                            alignItems: "center",
                            children: [
                                expanded && actions != null && /*#__PURE__*/ _jsx(Box, {
                                    onClick: stopBubble,
                                    children: actions
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    className: styles.chevron,
                                    children: expanded ? /*#__PURE__*/ _jsx(ChevronUp, {
                                        size: 20
                                    }) : /*#__PURE__*/ _jsx(ChevronDown, {
                                        size: 20
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Collapse, {
                    in: expanded,
                    children: /*#__PURE__*/ _jsx(Box, {
                        testId: TID.Body(),
                        className: styles.mobileBody,
                        children: children
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Card, {
        bi: bi,
        testId: testId,
        padding: "m",
        borderRadius: "m",
        title: title,
        actions: actions,
        className: styles.desktopCard,
        children: /*#__PURE__*/ _jsx(Box, {
            testId: TID.Body(),
            className: cn(styles.body, bodyClassName),
            children: children
        })
    });
}
